// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentContainer_root__tVxJU"};